import type { ChipOwnProps } from '@mui/material';
import type { Components, Theme } from '@mui/material/styles';
import { isNullOrUndefined } from '@vy/utils';

export const MuiChip: Components<Omit<Theme, 'components'>>['MuiChip'] = {
  styleOverrides: {
    outlined: ({ theme, ownerState }) => {
      const chipColor = getColor(ownerState.color);

      return {
        border: 'none',
        backgroundColor: ownerState.color === 'default' ? '#ECECED' : theme.palette[chipColor].selected,
        color: ownerState.color === 'default' ? theme.palette.common.black : theme.palette[chipColor].dark,
        '&:hover': {
          boxShadow: 'none',
        },
      };
    },
  },
};

function getColor(color?: ChipOwnProps['color']) {
  if (isNullOrUndefined(color) || color === 'default') {
    return 'primary';
  }

  return color;
}
